// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.popover_ae1b352a.popover_ae1b352a {
  width: 32.5rem;
  background-color: #fff;
  box-shadow: 0 8px 9px 0 rgba(0,0,0,0.24), 0 1px 8px 0 rgba(0,0,0,0.12);
  border: 0.084rem solid #dce1e5;
  border-radius: 0.333em;
  display: grid;
  grid-template-rows: 1fr;
}
.popover_body_ae1b352a {
  overflow: auto;
  max-width: 100%;
  padding: 2rem;
}
.popover-header_ae1b352a {
  font-family: PitchBookFont, 'Helvetica', 'Arial', sans-serif;
  font-weight: 600;
  font-size: 1.584rem;
  line-height: 1.5;
  letter-spacing: normal;
  color: #11304d;
  font-stretch: normal;
  padding-bottom: 2rem;
}
`, ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"popover": `popover_ae1b352a`,
	"popover_body": `popover_body_ae1b352a`,
	"popover-header": `popover-header_ae1b352a`
};
export default ___CSS_LOADER_EXPORT___;
